import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.use(AmplifyPlugin, AmplifyModules)
import * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

export default new Vuex.Store({
  state: {
    isLoading: false,
    user: null,
    username: null,
    tags: ["指定なし", "エリーゼのために", "カノン", "きらきら星"]
  },
  mutations: {
    setLoading(state, payload){
      state.isLoading = payload;
    },
    // ユーザー情報保存
    setUser(state, user) {
      state.user = user;
      if(user){
        state.username = user.username;
      }else{
        state.username = null;
      }
    },
  },
  actions: {
    getUser(ctx){
      // AWSログイン状態を確認して、ログイン状態であれば、ユーザー情報を取得
      // ユーザー情報を取得できたら、stateに登録する
      Vue.prototype.$Amplify.Auth.currentAuthenticatedUser()
      .then((user_data) => {
        if (user_data && user_data.signInUserSession) {
          ctx.commit('setUser', user_data);
        }})
      .catch(() => {
        ctx.commit('setUser', null);
      });
    }
  },
  modules: {
  }
})
